import AjaxCalls from '_loaders/AjaxCalls';
import config from '_config';
import jQuery from 'jquery';


class TH_Translate {
    constructor() {
        this.localization = null;
        this.defaultLanguage = null;
        this.initialized = false;
    }

    async init() {
        let selfRef = this,
            localization;

        if (config.languageCode === config.globalLanguage) this.localization = false;
        else {
            localization = await AjaxCalls.ajaxGet(config.siteUrl+'localization/get/' + config.languageCode + '/');
            if (localization.result === false) {
                console.error("Error fetching the localization file!", jQuery.extend(true, {}, this.localization));
                this.localization = null;
            } else this.localization = localization;
        }
        
        jQuery("th-to-translate").each(function() {
            let elem = jQuery(this),
                text = elem.data('text'),
                parameters = elem.data('parameters');

            elem.html(selfRef.text.apply(selfRef, [text].concat(parameters)));
            elem.unwrap();
        });
        return true;
    }

    async waitForInit() {
        return new Promise(function(resolve, reject) {
            let intervalCheck;

            if (this.initialized === true) resolve(true);
            else intervalCheck = setInterval(function() {
                if (this.initialized === true) {
                    clearInterval(intervalCheck);
                    resolve(true);
                }
            }.bind(this), 50);
        }.bind(this));

    }

    /** Translate text asynchronously
     * 
     */
    async asyncText() {
        await this.waitForInit();
        return this.text.apply(this, Array.prototype.slice.call(arguments));
    }


    /** Translate a text representation
     * 
     * @param bool   wrap (if the first parameter is provided as a boolean that resolves to true, the result will be wrapped in a <th-to-translate></th-to-translate> 
     *                     dom object, and this function will return a jQuery object instead of a string. With this, you can ensure that texts that are provided from
     *                     the javascript environment, will get translated as soon as the translater initializes. If you are planning to output the translation directly
     *                     to the dom, set this to true, otherwise, it is preferable to use the self::asyncText() asynchronous function together with this to ensure
     *                     translations when the translater is slow to retrieve the localization file)
     * @param string text (the text to translate)
     * @param string repl1...replX (additional values to replace the replacement objects in the text)
     * 
     * @return string|jQuery
     */
    text() {
        let parameters = Array.prototype.slice.call(arguments),
            text = parameters.shift(),
            textReplaced,
            wrap = false;

        if (text === true) {
            wrap = true;
            text = parameters.shift();
        } else if (text === false) text = parameters.shift();

        
        if (this.localization === null) {
            if (wrap === true) wrap = jQuery("<th-to-translate></th-to-translate>").data('text', text).data('parameters', parameters);
        } else if (this.localization !== false) {
            if (typeof this.localization[text] === 'undefined') {
                if (process.env.NODE_ENV == 'development') {
                    AjaxCalls.ajaxPost(config.siteUrl+'localization/add/', {
                        add: text,
                        key: '$2a$07$HQLXR7H9lnqYD6RD3GWrfe6pXU0G87tdkJakEgKobqCKWsJS.ZnLa'
                    });
                }

                this.localization[text] = null;
            }

            if (this.localization[text] !== null) text = this.localization[text];
        }

        textReplaced = text;
        for (let i in parameters) textReplaced = textReplaced.replace("%"+i, parameters[i]);

        if (wrap !== false) wrap.html(textReplaced);
        else wrap = textReplaced;

        return wrap;
    }
}

export default TH_Translate;    